/* eslint-disable no-prototype-builtins */
import './CvTheque.scss';

import { Add, Link, Search } from '@mui/icons-material';
import { StarBorder } from '@mui/icons-material';
import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { Button, IconButton, Tooltip, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';

import CategoriesSubCategoriesDropDown from '../../../Components/CategoriesSubCategoriesDropDown';
import DialogClasserCvs from '../../../Components/Dialogs/DialogClasserCvs';
import DialogLierCvs from '../../../Components/Dialogs/DialogLierCvs';
import CvAnonyme from '../../../Components/Docs/CvAnonyme';
import { buttonStyles } from '../../../Components/docsAdministrative/JsObjectStyles';
// import ChipComponent from '../../../Components/shared/ChipComponent';
import { MaterialTableComponent, TextFieldComponent } from '../../../Components/shared/ReusableSmallComponents';
import { genreList, modeTravailEnum } from '../../../data/Interfaces';
import { InitSearchSVG } from '../../../data/SVGs';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import useCraRdv from '../../../hooks/useCraRdv';
import { useNumberFormatting } from '../../../hooks/useNumberFormatting';
import useUtilities from '../../../hooks/useUtilities';
import useWindowSize from '../../../hooks/useWindowSize';
import { formatDateJJMMYYYY } from '../../../Utils/dateFormatter';
import { calculateTotalAnneeExperience, getDateDisponibilite, getExpertCompetences, getNomPrenomAnonymeFromPersoData, searchLabelInEnumByValue } from '../../../Utils/utils';
import { getPaymentSimulationResults } from '../../../Utils/utilsCraX';
const SEARCH_MODE = 'IA';
// const SEARCH_MODE = 'BD';
export function convertMongoDocIntoMongooseOne(obj) {
    /**
     * Recursively loop through an object and replace all occurrences of { $date: 'dateStringValue' }
     * with 'dateStringValue' as the value of the corresponding key.
     *
     * @param {object} obj - The object to be processed.
     * @returns {object} - The modified object with replaced date values.
     */
    try {
        // Check if the input is an object
        if (typeof obj !== 'object' || obj === null) {
            throw new TypeError('Input must be an object');
        }

        // Iterate through each key in the object
        for (let key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key)) { // is the same as : if (obj.hasOwnProperty(key)) {
                if ( typeof obj[key] === 'object' && obj[key] !== null && obj[key].hasOwnProperty('$date') && typeof obj[key]['$date'] === 'string' ) {
                    // Replace the value with the date string value
                    obj[key] = obj[key]['$date'];
                }
                if ( typeof obj[key] === 'object' && obj[key] !== null && obj[key].hasOwnProperty('$oid') && typeof obj[key]['$oid'] === 'string' ) {
                    // Replace the value with the date string value
                    obj[key] = obj[key]['$oid'];
                }
                // Check if the value is an object
                else if (typeof obj[key] === 'object' && obj[key] !== null) {
                    // Recursively call the function for nested objects
                    obj[key] = convertMongoDocIntoMongooseOne(obj[key]);
                }
            }
        }

        return obj;
    } catch (error) {
        // Log the error
        console.error('Error:', error);
        return null;
    }
}
function CvThequeSimpleSearch() {
    const { addEuro4Decimal } = useNumberFormatting();

    const axiosPrivate = useAxiosPrivate();
    const { ListStatutCv, setListStatutCv } = useCraRdv();
    const { setBackdropOpen } = useUtilities();
    const [categorie, setCategorie] = useState('');
    const [sousCategorie, setSousCategorie] = useState('');
    const [searchedSkillsTech, setSearchedSkillsTech] = useState();//* [] when it was a list of skills with the chip component
    // const [experts, setExperts] = useState([]);
    const [expert, setExpert] = useState();
    // const [expertsOrigin, setExpertsOrigine] = useState([]);
    const [selectedExperts, setSelectedExperts] = useState([]);
    //const {cvListStatut,setCvListStatut} = useCraRdv();
    const [cvOpen, setCvOpen] = useState(false);
    const [cvthequeExperts, setCvthequeExperts] = useState([]);
    const { i18n } = useTranslation();
    const [openClasser, setOpenClasser] = useState(false);
    const [openLier, setOpenLier] = useState(false);
    const {device}=useWindowSize();

    useEffect(() => {
        search(true);
    }, []);
    // * before using IA
    // useEffect(() => {
    //     if (searchedSkillsTech || sousCategorie || categorie)
    //         search();
    // }, [searchedSkillsTech, sousCategorie, categorie]);

    // useEffect(() => {
    //     // console.log(categorie, sousCategorie,{array: expertsOrigin,property:'categorie',searchedValue:sousCategorie,categorie});
    //     // console.log('search result sousCategorie', sousCategorie, 'categorie', categorie, searchStringInsideSpecificPropetyOfArrayofObjects({
    //     //     array: expertsOrigin,
    //     //     property: 'categorie',
    //     //     searchedValue: sousCategorie,
    //     //     categorie
    //     // }));
    //     // ! let do all the request on the backend [even for categories]
    //     //* the idea of storing a list of origin expert will also took a lot of memory
    //     // setExperts(searchStringInsideSpecificPropetyOfArrayofObjects({ array: expertsOrigin, property: 'categorie', searchedValue: sousCategorie, categorie }));
    //     // * in this case the filter will work only for the first load
    //     setCvthequeExperts(searchStringInsideSpecificPropetyOfArrayofObjects({ array: cvthequeExperts, property: 'categorie', searchedValue: sousCategorie, categorie }));
    // }, [sousCategorie, categorie]);

    // ? fill in the data
    const loadDataToTheTable = (experts, isInitialRequest) => {
        let Array1 = [];
        let annExp = 0;
        if (SEARCH_MODE == 'BD' || isInitialRequest) {
            experts?.map((expert, i) => {
                console.log('candidatttttttttt', expert, i);
                annExp = expert?.proData?.otherInfo?.totalAnneeExperience ?? calculateTotalAnneeExperience(expert?.proData?.experiences);
                Array1.push({
                    'id': expert?._id,
                    'matching': '%',
                    'titre': expert?.persoData?.genre,
                    'nom': getNomPrenomAnonymeFromPersoData(expert?.persoData),
                    'intitulePoste': expert?.persoData?.intitulePoste,
                    // to discuss : bcp de competences => comment on va les afficher ? et est ce que on peux afficher 20 competences !!
                    'competences': getExpertCompetences(expert?.proData?.competencesTechnique),
                    //'favoris':getStatutCv('favoris',ListStatutCv,expert?._id)==' ' ? 'nonFav' : getStatutCv('favoris',ListStatutCv,expert?._id),
                    //'statutCv' : getStatutCv('Lu',ListStatutCv,expert?._id)==' ' ? 'Non lu' : getStatutCv('Lu',ListStatutCv,expert?._id),
                    'tauxJournalier': getPaymentSimulationResults({ tj: expert?.preference?.tjm, commissionHTH: 0.2 })?.tjClient,
                    'ville': expert?.preference?.residence?.ville,
                    'pays': expert?.preference?.residence?.pays,
                    //'evaluation': (expert?.recommendation?.evaluation+ '4.5'),
                    //'commentaire': (expert?.recommendation?.commentaire),
                    // TODO: later add this with the user updatedAt
                    'DerniereActivite': formatDateJJMMYYYY(expert?.updatedAt),
                    // ? !! donnees a discuter
                    'tatalAnneeExperience': annExp,
                    'dateDisponibilite': getDateDisponibilite(expert?.preference?.dateDisponibilite),
                    'modeTravail': expert?.preference?.modeTravail?.type,
                    ...expert
                });
            });
        }
        else if (SEARCH_MODE == 'IA') {
            experts?.map((expert, i) => {
                console.log('candidatttttttttt', expert, i);
                const expertData = convertMongoDocIntoMongooseOne(expert?.expertData);
                annExp = expertData?.proData?.otherInfo?.totalAnneeExperience ?? calculateTotalAnneeExperience(expertData?.proData?.experiences);
                Array1.push({
                    'id': expert?.expert_id,
                    '_id': expert?.expert_id,
                    // '_id': expert?.expert_id['$oid'],
                    // '_id': JSON.parse(expert?._id)[0]?.$oid,
                    'matching': addEuro4Decimal((expert?.matching_score * 100).toFixed(2), '%'),
                    'titre': expertData?.persoData?.genre,
                    'nom': getNomPrenomAnonymeFromPersoData(expertData?.persoData),
                    'intitulePoste': expertData?.persoData?.intitulePoste,
                    // to discuss : bcp de competences => comment on va les afficher ? et est ce que on peux afficher 20 competences !!
                    'competences': getExpertCompetences(expertData?.proData?.competencesTechnique),
                    //'favoris':getStatutCv('favoris',ListStatutCv,expert?._id)==' ' ? 'nonFav' : getStatutCv('favoris',ListStatutCv,expert?._id),
                    //'statutCv' : getStatutCv('Lu',ListStatutCv,expert?._id)==' ' ? 'Non lu' : getStatutCv('Lu',ListStatutCv,expert?._id),
                    'tauxJournalier': getPaymentSimulationResults({ tj: expertData?.preference?.tjm, commissionHTH: 0.2 })?.tjClient,
                    'ville': expertData?.preference?.residence?.ville,
                    'pays': expertData?.preference?.residence?.pays,
                    //'evaluation': (expert?.recommendation?.evaluation+ '4.5'),
                    //'commentaire': (expert?.recommendation?.commentaire),
                    // TODO: later add this with the user updatedAt
                    'DerniereActivite': formatDateJJMMYYYY(expertData?.updatedAt),
                    // ? !! donnees a discuter
                    'tatalAnneeExperience': addEuro4Decimal(annExp, 'ans'),
                    'dateDisponibilite': getDateDisponibilite(expertData?.preference?.dateDisponibilite),
                    'modeTravail': expertData?.preference?.modeTravail?.type,
                    ...expertData
                });
            });
        }
        console.log('Array1', Array1);
        setCvthequeExperts(Array1);
    };

    const search = async (isInitialRequest = false) => {
        setBackdropOpen(true);
        if (SEARCH_MODE == 'BD' || isInitialRequest)
            try {
                const response1 = await axiosPrivate.post('/cvTheque/searchExpert',
                    { searchedSkillsTech },
                );
                loadDataToTheTable(response1.data.experts, isInitialRequest);
                // setExperts(response1.data.experts);
                // setExpertsOrigine(response1.data.experts);
                setBackdropOpen(false);
            } catch (error) {
                console.log(error.response?.status);
                Swal.fire({
                    text: i18n.t(error.response?.data.error)
                });
            }
        else if (SEARCH_MODE == 'IA')
            try {
                const response1 = await axiosPrivate.post('/proxy/fast_search',

                    {
                        'categorie': {
                            'value': categorie,
                            'sousCategorie': sousCategorie, //(par defaut: allSubCategories)
                        },
                        'keywords': searchedSkillsTech
                    }
                    ,
                );
                // setExperts(response1.data);
                loadDataToTheTable(response1.data, isInitialRequest);
                // setExpertsOrigine(response1.data);
                setBackdropOpen(false);
            } catch (error) {
                console.log(error.response?.status);
                Swal.fire({
                    // text: error
                    text: i18n.t(error.response?.data.error)
                });
            }
    };

    const handleInitialiseSearch = () => {
        setCategorie('');
        setSousCategorie('');
        setSearchedSkillsTech('');
        setSelectedRow(null);
        setSelectedExperts([]);
        search(true);

        // old setAos(aosOrigin);
        // search();
    };

    const cvThequeColumns = [
        {
            field: 'matching',
            title: i18n.t('Matching'),
            //enableRowSpan: true,
            //Filter: FilterForm,
        },
        {
            field: 'favoris',
            title: i18n.t('Favoris'),
            render: rowData => {
                const isFavoris = ListStatutCv.some(el => el.id === rowData?.id && el.statut.includes('favoris'));

                const handleFavoriteClick = () => {
                    setListStatutCv(prevListStatutCv => {
                        let updatedListStatutCv = [...prevListStatutCv];
                        const index = updatedListStatutCv.findIndex(obj => obj.id === rowData?.id);

                        if (index === -1) {
                            updatedListStatutCv.push({ id: rowData?.id, statut: ['favoris'] });
                        } else {
                            if (!updatedListStatutCv[index]['statut'].includes('favoris')) {
                                updatedListStatutCv[index]['statut'].push('favoris');
                            } else {
                                updatedListStatutCv[index]['statut'] = updatedListStatutCv[index]['statut'].filter(s => s !== 'favoris');
                            }
                        }

                        console.log('ListStatutCv', updatedListStatutCv, 'rowdata id', rowData?.id);
                        return updatedListStatutCv;
                    });
                };

                return (
                    <>
                        {isFavoris ? (
                            <FavoriteIcon onClick={handleFavoriteClick} />
                        ) : (
                            <FavoriteBorderIcon onClick={handleFavoriteClick} />
                        )}
                    </>
                );
            },
        },
        {
            field: 'eye',
            title: i18n.t('CV'),
            render: rowData => {
                let found = ListStatutCv.find(el => el?.id == rowData?.id);
                if (found == undefined || (found != undefined && !found['statut'].includes('Lu')))
                    return (
                        <VisibilityOutlinedIcon
                            onClick={() => {
                                setExpert(rowData);

                                //code pour éviter d'avoir des experts redondants, si l'expert
                                //existe déjà nous l'ajoutons avec le statut désiré sinon nous
                                //recherchons l'index d'expert et on lui ajout le statut dans sa
                                //liste des statuts.
                                let arr = ListStatutCv;
                                const index = arr.findIndex(obj => {
                                    return obj.id === rowData?.id;
                                });
                                console.log('index', index);
                                if (index == -1)
                                    arr.push({ id: rowData?.id, statut: ['Lu'] });
                                else {
                                    if (!arr[index]['statut'].includes('Lu'))
                                        arr[index]['statut'].push('Lu');
                                }

                                setListStatutCv(arr);
                                console.log('ListStatutCv', ListStatutCv, 'arr after select', arr);
                                setCvOpen(true);
                            }}
                        />
                    );
                else
                    return (
                        <VisibilityIcon
                            onClick={() => {
                                setExpert(rowData);
                                const arr = ListStatutCv.map(obj => {
                                    if (obj.id === rowData?.id) {
                                        return {
                                            id: obj.id,
                                            statut: obj.statut.filter(s => s !== 'Lu')
                                        };
                                    } else {
                                        return obj;
                                    }
                                });
                                //let arr=ListStatutCv;
                                //const index = arr.findIndex(obj => {
                                //    return obj.id === rowData?.id;
                                //});
                                //const index2 = arr[index]['statut'].indexOf('Lu');
                                //if (index2 !== -1) {
                                //    arr[index]['statut'].splice(index2, 1);

                                //}
                                console.log('ListStatutCv', ListStatutCv, 'arr after deseclt', arr);
                                setListStatutCv(arr);
                            }}
                        />
                    );

            }
            //<RemoveRedEye
            //    style={{cursor: 'pointer'}}
            //    onClick={() => {
            //        setExpert(rowData);
            //        setCvOpen(true);
            //        let arr=ListStatutCv;
            //        const index = arr.findIndex(obj => {
            //            return obj.id === rowData?.id;
            //        });
            //        console.log('index',index);
            //        if(index==-1)
            //            arr.push({id:rowData?.id,statut:['lu']});
            //        else if(!arr[index]['statut'].includes('lu'))
            //            arr[index]['statut']=['lu','favoris'];

            //        setListStatutCv(arr);
            //    }}
            ///>
        },
        {
            field: 'titre',
            title: i18n.t('Titre'),
            render: (rowData) =>
                searchLabelInEnumByValue(genreList, rowData.titre)
            // enableRowSpan: true
        },
        {
            field: 'nom',
            title: i18n.t('Nom'),
            // enableRowSpan: true
        },
        {
            field: 'intitulePoste',
            title: i18n.t('Intitulé du CV'),
            // enableRowSpan: true
        },
        {
            field: 'competences',
            title: i18n.t('Compétences'),
            render: (rowData) =>
                rowData?.competences ?? getExpertCompetences(rowData?.proData?.competencesTechnique)
            // enableRowSpan: true
        },
        {
            field: 'tatalAnneeExperience',
            title: i18n.t('Total Exp.'),
            render: rowData => {
                return addEuro4Decimal(rowData?.tatalAnneeExperience, i18n.t('ans'));
            }
        },
        {
            field: 'statutCv',
            title: i18n.t('Statut CV'),
            render: rowData => {
                //const isFavoris = ListStatutCv.some(el => el.id === rowData?.id && el.statut.includes('favoris'));
                const isLu = ListStatutCv.some(el => el.id === rowData?.id && el.statut.includes('Lu'));
                return (
                    <>
                        {isLu ? (
                            <p style={{ margin: '0' }}>Lu</p>
                        ) : (
                            <p style={{ margin: '0' }}>Non lu</p>
                        )}
                    </>
                );
            }
        },
        {
            field: 'dateDisponibilite',
            title: i18n.t('Date de disponibilité'),
            render: (rowData)=>
                i18n.t(rowData?.dateDisponibilite)
            //render: (rowData)=>
            //    formatDateJJMMYYYY(rowData.dateDisponibilite)

        },
        {
            field: 'tauxJournalier',
            title: i18n.t('Taux journalier'),
            render: rowData =>
                addEuro4Decimal(rowData?.tauxJournalier)
        },
        {
            field: 'modeTravail',
            title: i18n.t('Mode de travail'),
            render: (rowData) =>
                i18n.t(searchLabelInEnumByValue(modeTravailEnum, rowData.modeTravail))

        },
        {
            field: 'pays',
            title: i18n.t('Pays'),
        },
        {
            field: 'ville',
            title: i18n.t('Ville'),
        },
        {
            field: 'evaluation',
            title: i18n.t('Evaluation'),
            render: () =>
                //faut ajouter un traitement selon la notation du client soit on affiche start ou half start
                <StarBorder />
        },
        //{
        //    field: 'commentaire',
        //    title: i18n.t('Commentaire',
        //    render: () =>
        //        //faut ajouter un traitement selon la notation du client soit on affiche start ou half start
        //        <Chat />
        //},
        {
            field: 'DerniereActivite',
            title: i18n.t('Dernière activité'),
        },
    ];
    console.log('test');
    const [selectedRow, setSelectedRow] = React.useState(null);
    return (
        <>
            <form className='frame121212CvTheque'>
                <div
                    className='frame4CvTheque'
                    style={{ flexDirection: device=='desktop' ?'row':'column',gap: device=='desktop' ?'8px':'16px' }}
                >

                    {device=='desktop' &&
                    <>
                        <Tooltip  title='Clear' >
                            <IconButton onClick={handleInitialiseSearch}>
                                <InitSearchSVG />
                            </IconButton>
                        </Tooltip>

                        <CategoriesSubCategoriesDropDown
                            setCategorie={setCategorie}
                            setSousCategorie={setSousCategorie}
                            sousCategorie={sousCategorie}
                            width='30%'
                            label={i18n.t('Catégories')}
                        />

                        <TextFieldComponent
                            id="margin-none"
                            // multiline
                            value={searchedSkillsTech}
                            name='search'
                            onChange={(newValue) => {
                                setSearchedSkillsTech(newValue.target.value);
                            }}
                            style={{ width: '75%' || '261.25px' }}
                            sx={{
                                '& > :not(style)': { borderRadius: '8px' },
                            }}
                            placeholder={i18n.t('Mots clés, exemple: (Angular ou “Node JS”) et React')}
                        />
                        <Tooltip
                            title={
                                <Typography component="div">
                                    <p>{i18n.t('Opérateurs et syntaxes:')}</p>
                                    <ul>
                                        <li>
                                            {i18n.t('A ET B: La recherche des CV qui doivent inclure A et B')}
                                        </li>
                                        <li>{i18n.t('A OU B: La recherche des CV qui incluent A et B ou les 2')}</li>
                                        <li>{i18n.t('“A B”: La recherche d\'un mot clé composé de deux mots (ex. “Spring Boot”)')}</li>
                                        <li>{i18n.t('(A OU B) et (C OU D): Les () pour affiner la recherche')}</li>
                                    </ul>
                                    <p>{i18n.t('A savoir:')}</p>
                                    <ul>
                                        <li>
                                            {i18n.t('Les recherches sont insensibles à la casse (Maj/min)')}
                                        </li>
                                    </ul>
                                </Typography>
                            }
                        >
                            <IconButton style={{padding:'0px',height:'30px',alignSelf:'center'}}>
                                <InfoOutlinedIcon />
                            </IconButton>
                        </Tooltip>

                        {/* {/* //? no need : Categories : workd without backend , and chip Input works on backend with onchage [useEffect] */}
                        <Tooltip  title='Search' >
                            <IconButton
                                type='submit'
                                variant='contained'
                                color='primary'
                                size="large"
                                style={{padding:'0px',height:'30px',alignSelf:'center'}}
                                onClick={(e) => {
                                    e.preventDefault();
                                    search();
                                } }
                            >
                                <Search />
                            </IconButton>
                        </Tooltip>
                    </>
                    }
                    {/* <ChipComponent
                        //suggestionsSet={techSkillSet}
                        chipArray={searchedSkillsTech}
                        setChipArray={setSearchedSkillsTech}
                        width={'80%'}
                        // * like guru : placeholder={'quelle compétence recherchez-vous'}
                        placeholder={'Mots clés, exemple: (Angular ou “Node JS”) et React'}
                    /> */}
                    {device!='desktop' &&
                    <div style={{display:'flex',flexDirection:'row',gap:'8px'}}>

                        <TextFieldComponent
                            id="margin-none"
                            // multiline
                            value={searchedSkillsTech}
                            name='search'
                            onChange={(newValue) => {
                                setSearchedSkillsTech(newValue.target.value);
                            }}
                            style={{ width: '100%' }}
                            sx={{
                                '& > :not(style)': { borderRadius: '8px' },
                            }}
                            placeholder={i18n.t('Mots clés, exemple: (Angular ou “Node JS”) et React')}
                        />
                    </div>

                    }

                    {device!='desktop' &&
                    <div style={{display:'flex',flexDirection:'row',gap:'8px'}}>
                        <CategoriesSubCategoriesDropDown
                            setCategorie={setCategorie}
                            setSousCategorie={setSousCategorie}
                            sousCategorie={sousCategorie}
                            width='100%'
                            label={i18n.t('Catégories')}
                        />
                        <Tooltip  title='Clear' >
                            <IconButton onClick={handleInitialiseSearch}>
                                <InitSearchSVG />
                            </IconButton>
                        </Tooltip>

                        {/* {/* //? no need : Categories : workd without backend , and chip Input works on backend with onchage [useEffect] */}
                        <Tooltip  title='Search' >
                            <IconButton
                                type='submit'
                                variant='contained'
                                color='primary'
                                size="large"
                                style={{padding:'0px',height:'30px',alignSelf:'center'}}
                                onClick={(e) => {
                                    e.preventDefault();
                                    search();
                                } }
                            >
                                <Search />
                            </IconButton>
                        </Tooltip>
                        <Tooltip
                            title={
                                <Typography component="div">
                                    <p>{i18n.t('Opérateurs et syntaxes:')}</p>
                                    <ul>
                                        <li>
                                            {i18n.t('A ET B: La recherche des CV qui doivent inclure A et B')}
                                        </li>
                                        <li>{i18n.t('A OU B: La recherche des CV qui incluent A et B ou les 2')}</li>
                                        <li>{i18n.t('“A B”: La recherche d\'un mot clé composé de deux mots (ex. “Spring Boot”)')}</li>
                                        <li>{i18n.t('(A OU B) et (C OU D): Les () pour affiner la recherche')}</li>
                                    </ul>
                                    <p>{i18n.t('A savoir:')}</p>
                                    <ul>
                                        <li>
                                            {i18n.t('Les recherches sont insensibles à la casse (Maj/min)')}
                                        </li>
                                    </ul>
                                </Typography>
                            }
                        >
                            <IconButton style={{padding:'0px',height:'30px',alignSelf:'center'}}>
                                <InfoOutlinedIcon />
                            </IconButton>
                        </Tooltip>

                    </div>
                    }
                </div>
                <div
                    className='frame4CvTheque'
                    style={{ flexDirection: 'row' }}
                >
                    <div className='frame9CvTheque'>
                        <Tooltip title={i18n.t('Ajouter à un dossier')}>
                            <Button
                                variant='outlined'
                                startIcon={<Add />}
                                style={{...buttonStyles(((selectedExperts.length > 0 )?false:true)),...{height:'36px'}}}
                                onClick={() => (selectedExperts.length > 0) && setOpenClasser(true)}
                            >{device=='desktop' ? i18n.t('Ajouter à un dossier') : ''}</Button>
                        </Tooltip>
                    </div>
                    <div className='frame9CvTheque'>
                        <Tooltip title={i18n.t('Lier à un appel d\'offres')}>
                            <Button
                                variant='outlined'
                                startIcon={<Link />}
                                style={{...buttonStyles(((selectedExperts.length > 0 )?false:true)),...{height:'36px'}}}
                                onClick={() => (selectedExperts.length > 0) && setOpenLier(true)}
                            >{device=='desktop' ? i18n.t('Lier à un appel d\'offres') : ''}</Button>
                        </Tooltip>
                    </div>
                </div>
                <div className='HomeFrame'>
                    <MaterialTableComponent
                        columns={cvThequeColumns}
                        data={cvthequeExperts}
                        title="Cvtheque"
                        options={{
                            selection: true
                        }}
                        onRowClick={(event, rowData) => {
                            setSelectedRow(rowData?.tableData.id);
                        }}
                        key={ListStatutCv.length}
                        selectedRow={selectedRow}
                        onSelectionChange={(rows) => {
                            console.log({ rows });
                            setSelectedExperts(rows);
                        }}
                    />

                    <CvAnonyme
                        setOpenCvAnonyme={setCvOpen}
                        expert={expert}
                        openCvAnonyme={cvOpen}
                        refreshParentTable={search}
                        visualiseCvOnly={true}
                        necessaryRefresh={false}
                    >
                    </CvAnonyme>
                    {openClasser &&
                        <DialogClasserCvs
                            selectedExperts={selectedExperts}
                            openClasser={openClasser}
                            handleCloseClasser={() => setOpenClasser(false)}
                        />}
                    {openLier &&
                        <DialogLierCvs
                            selectedExperts={selectedExperts}
                            openLier={openLier}
                            setOpenLier={setOpenLier}
                        />}
                </div>
            </form>
        </>
    );
}

export default CvThequeSimpleSearch;